import React from 'react';  
import { Modal, Button, List, Typography } from 'antd';  
const { Text } = Typography;  
  
const GroupMembersModal = ({ visible, onClose, groupMembers, groupName }) => (  
  <Modal  
    title={`Group Members: ${groupName}`}  
    open={visible} // NOTE: `open` (Antd v4.23+) instead of `visible` (deprecated)  
    onCancel={onClose}  
    footer={[  
      <Button key="close" onClick={onClose}>  
        Close  
      </Button>  
    ]}  
  >  
    <List  
      dataSource={groupMembers}  
      renderItem={member => (  
        <List.Item>  
          <Text>  
            {member.name ? member.name : <b>Error: Missing name</b>}<br/>  
            ID: {member.id_number ? member.id_number : <b>Missing ID</b>}  
          </Text>  
        </List.Item>  
      )}  
    />  
  </Modal>  
);  
  
export default GroupMembersModal;  